import { render, staticRenderFns } from "./AboutCommitteesHeader.vue?vue&type=template&id=0518ba7c&"
import script from "./AboutCommitteesHeader.vue?vue&type=script&lang=js&"
export * from "./AboutCommitteesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports